package kz.dentalcrm.app.screens.patients.detail.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect

sealed interface PatientDetailSideEffect : ViewSideEffect {
    data object UpdateSuccess : PatientDetailSideEffect
    data object DeleteSuccess : PatientDetailSideEffect
    data class ShowError(val message: String) : PatientDetailSideEffect
}